import cls from 'classnames'
import styles from './DefaultAvatar.module.less'
import { CSSProperties, useState } from 'react'

const RANDOM_COLORS = ['#F68E94', '#CD7EED', '#6EAFF7', '#E79B3E', '#BDBB24', '#43DAD6']

const normalizeName = (name?: string) => (name || '-').trim().toLowerCase()

const getHash = (text: string) => {
  let hash = 5381
  for (let i = 0; i < text.length; i += 1) {
    hash = (hash << 5) + hash + text.charCodeAt(i)
  }
  return hash >>> 0
}

const getStableColorByName = (name?: string) => {
  const normalizedName = normalizeName(name)
  const hash = getHash(normalizedName)
  return RANDOM_COLORS[hash % RANDOM_COLORS.length]
}

function DefaultAvatar(props: {
  name: string
  avatar?: string | null
  className?: string
  width?: number
  height?: number
  style?: CSSProperties
}) {
  const currentColor = getStableColorByName(props.name)
  const [showAvatar, setShowAvatar] = useState(Boolean(props.avatar))
  const handleAvatarError = () => {
    console.log('load error')
    setShowAvatar(false)
  }
  return showAvatar ? (
    <img
      className={cls(styles.defaultAvatar, props.className)}
      style={{ ...props.style, background: currentColor, width: props.width, height: props.height }}
      src={props.avatar || ''}
      onError={handleAvatarError}
      alt=''
    />
  ) : (
    <span
      className={cls(styles.defaultAvatar, props.className)}
      style={{ ...props.style, background: currentColor, width: props.width, height: props.height }}
    >
      {props.name ? props.name.slice(0, 1) : '-'}
    </span>
  )
}

export default DefaultAvatar
